<template>
  <el-container>
    <el-header>
      <el-row>
        <el-col :span="8">
          <p style="display: inline-block; width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
            class="text-4">
            <img v-if="$store.state.companyLogo" :src="$store.state.companyLogo"
              style="margin-top: -3px; height: 30px" />&nbsp;
            <span>|</span>
            <!-- {{ $store.state.adminSetting.adst03 || "BIM协同管理云平台" }} -->
            {{ $store.state.Company || "BIM协同管理云平台" }}
          </p>
        </el-col>
        <el-col :span="4">
          <el-row>
            <el-col :span="8">
              <div :class="$store.state.btnStyle[0]" @click="enterpriseIndex">
                <p><i class="el-icon-s-home indexIcon"></i>{{ $t('topbar.我的主页') }}</p>
              </div>
            </el-col>
            <el-col :span="8">
              <div :class="$store.state.btnStyle[1]" v-if="this.$store.state.isClickProject" @click="userControls">
                <p><i class="el-icon-s-operation indexIcon"></i>{{ $t('topbar.项目主页') }}</p>
              </div>
            </el-col>
            <el-col :span="8" v-if="
              this.$store.state.isClickProject && this.$store.state.isProject
            ">
              <div :class="$store.state.btnStyle[2]" @click="project">
                <p><i class="el-icon-s-tools indexIcon"></i>{{ $t('topbar.项目设置') }}</p>
              </div>
            </el-col>
            <el-col :span="8" v-if="
              !this.$store.state.isClickProject &&
              this.$store.state.ifEnterprise
            ">
              <div :class="$store.state.btnStyle[3]" @click="control">
                <p><i class="el-icon-s-platform indexIcon"></i>{{ $t('topbar.控制台') }}</p>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row justify="space-between" type="flex">
            <el-col :span="15" v-show="!this.$store.state.isClickProject">
              <span class="font-sz16">{{ $t('topbar.公司') }}：</span>
              <!-- 公司选择 -->
              <el-select filterable style="width: 70%;" v-model="$store.state.Company">
                <el-option @click.native="changeCompany(item)" v-for="(item, index) in CompanyList" :key="index"
                  :label="item.Company" :value="[item.comu03, item.comu04, index]"></el-option>
              </el-select>
            </el-col>
            <el-col v-show="this.$store.state.isClickProject" :span="15">
              <span class="font-sz16">{{ $t('topbar.项目') }}：</span>
              <el-select filterable v-model="$store.state.xidName" style="width: 70%;" @change="changeProject">
                <el-option v-for="(item, index) in ProjectList" :key="index" :label="item.proj07"
                  :value="[item.proj01, item.proj03, item.prou07, item.proj07]"></el-option>
              </el-select>
            </el-col>
            <el-col :span="9" class="dis-flex">
              <img class="img-two" src="@/assets/img/ren.png" alt />
              <el-select filterable v-if="this.$store.state.isClickProject" v-model="roleNameModel"
                class="inputBorder width70" placeholder="">
                <el-option v-for="(item, index) in $store.state.jobs" :key="index" :label="item.roleName"
                  :value="item.roleName" @click.native="changeJobs(item)"></el-option>
              </el-select>
              <span v-else class="box-one" :title="JobName">{{ JobName }}</span>

            </el-col>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-row>
            <!-- <el-col :span="5">
              <el-badge :is-dot="dot">
                <el-popover placement="left" :title="$t('personcenter.消息通知')" width="650">
                  <div style="height: 300px; overflow: auto;">
                    <el-row v-for="(project, index) in inFromProject" :key="index"
                      style="line-height: 40px; border-bottom: 1px solid #e8e8e8">
                      <el-col :span="2">
                        <img style="
                          width: 30px;
                          height: 30px;
                          margin-bottom: 10%;
                          border-radius: 50%;
                        " :src="$store.state.baseUrl + project.ImageUrl" alt />
                      </el-col>
                      <el-col :span="11">
                        <i v-if="project.UrgeState == 1" class="el-icon-alarm-clock"
                          style="color: red; margin-right: 5px"></i>
                        <span>
                          {{
                            project.Msg.length > 20
                              ? project.Msg.substring(0, 20) + "..."
                              : project.Msg
                          }}
                        </span>
                      </el-col>
                      <el-col :span="6">{{ project.Time }}</el-col>
                      <el-col :span="5" style="display: flex">
                        <el-popconfirm v-if="project.IsAgree == null" :title="$t('common.同意询问')"
                          @confirm="consent(project)">
                          <el-button slot="reference" type="text">{{ t('common.同意') }}</el-button>
                        </el-popconfirm>
                        <el-popconfirm v-if="project.IsAgree == null" :title="$t('common.拒绝询问')"
                          @confirm="refuse(project)">
                          <el-button slot="reference" type="text" style="color: #e6a23c; margin: 0 20px">{{
                            t('common.拒绝') }}</el-button>
                        </el-popconfirm>
                        <el-popconfirm confirm-button-text="OK" :cancel-button-text="$('common.取消')" icon="el-icon-info"
                          icon-color="red" :title="$t('common.删除询问')" @confirm="delect(project)">
                          <el-button slot="reference" type="text" style="color: red">{{ $t('common.删除') }}</el-button>
                        </el-popconfirm>
                      </el-col>
                    </el-row>
                  </div>
                  <i style="font-size: 20px; cursor: pointer" class="el-icon-message-solid" slot="reference"
                    @click="Inform"></i>
                </el-popover>
              </el-badge>
            </el-col> -->
            <!-- <el-col :span="5">
              <i style="font-size: 21px; cursor: pointer;color: black;" class="el-icon-question"
                v-if="$route.name != 'enterpriseIndex'" @click="openHelp"></i>
            </el-col> -->
            <el-col :span="4">
              <el-button
                style="height: 40px;border-radius: 10px;width: 40px;border: 1px solid black;text-align: center;padding: 0;"
                @click="Language(currentLanguage)">{{ currentLanguage
                  === 'zh'
                  ? 'EN' : '中' }}</el-button>
            </el-col>
            <el-col :span="5">
              <el-dropdown trigger="click" style="margin: auto;">
                <userImage :username="UserNames" :imgUrl="$store.state.UserImgs">
                </userImage>
                <div class="gr" v-if="viewShows">
                  <el-dropdown-menu slot="dropdown" class="user-dropdown">
                    <el-dropdown-item class="margin0" divided @click.native="my">
                      <span class="dis-bok-wh100">{{ $t("personcenter.个人中心") }}</span>
                    </el-dropdown-item>
                    <el-dropdown-item class="margin0" divided @click.native="Updatepwd">
                      <span class="dis-bol-wh100">{{ $t("personcenter.修改密码") }}</span>
                    </el-dropdown-item>

                    <!-- <el-dropdown-item class="margin0" divided @click.native="addFirm">
                      <span class="dis-bok-wh100">{{ $t('personcenter.加入企业') }}</span>
                    </el-dropdown-item> -->

                    <el-dropdown-item class="margin0" divided @click.native="out">
                      <span class="dis-bok">{{ $t("personcenter.退出登录") }}</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </div>
              </el-dropdown>
            </el-col>
            <el-col :span="15" class="box-two">
              <el-tooltip effect="dark" :content="UserNames" placement="top-start">
                <span style="color: black;">{{ UserNames }}</span>
              </el-tooltip>
            </el-col>

          </el-row>
        </el-col>
      </el-row>
    </el-header>
    <div class="view">
      <router-view v-if="viewShow" ref="view"></router-view>
    </div>
    <!-- 申请加入企业 -->
    <el-dialog title="申请加入企业" :visible.sync="dialogVisible" :close-on-click-modal="false" width="50%" center>
      <el-form :model="FirmForm" ref="FirmForm" label-position="top" style="margin-left: 20%" :rules="Firmrules">
        <el-form-item label="请输入企业编码：" prop="companycode">
          <el-input v-model="FirmForm.companycode" placeholder="只支持精确搜索，不能模糊搜索" autocomplete="off"
            style="width: 450px"></el-input>
        </el-form-item>
        <el-form-item label="选择企业组织架构：" prop="deptid">
          <el-select style="width: 450px" v-model="FirmForm.deptid" clearable placeholder="请选择企业组织架构">
            <el-option v-for="item in dept" :key="item.dept01" :label="item.dept02" :value="item.dept01"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择企业职位：" prop="jobid">
          <el-select clearable style="width: 450px" v-model="FirmForm.jobid" placeholder="请选择企业职位">
            <el-option v-for="item in job" :key="item.cptt01" :label="item.cptt03" :value="item.cptt01"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button style="float: right" type="text" @click="GetApplyRecord">申请记录</el-button>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitFirm('FirmForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="申请记录" :visible.sync="application" width="50%" :close-on-click-modal="false" center>
      <div style="height: 300px; overflow: auto; hiddenScroll: true">
        <el-row v-for="(firm, index) in inFromFirm" :key="index"
          style="line-height: 40px; border-bottom: 1px solid #e8e8e8;">
          <el-col :span="10">
            <span>您已</span>
            <span style="color: #42a3fd">{{ firm.Msg.substr(2, 2) }}</span>
            <span>加入</span>
            <span style="color: #42a3fd">{{ firm.CompanyorProject }}</span>
            <span>企业</span>
          </el-col>
          <el-col :span="6">{{ firm.Time }}</el-col>
          <el-col :span="2">
            {{
              firm.State == 1 ? "已通过" : firm.State == 0 ? "已拒绝" : "审核中"
            }}
          </el-col>
          <el-col :span="6" style="display: flex">
            <el-popconfirm title="要催办该条请求吗？" @confirm="SetUrge1(firm.Id)">
              <el-button slot="reference" type="text">催办</el-button>
            </el-popconfirm>
            <el-popconfirm title="要撤销该条请求吗？" @confirm="DelApply(firm.Id)">
              <el-button slot="reference" type="text" style="color: red; margin: 0 20px">撤销</el-button>
            </el-popconfirm>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="application = false">取 消</el-button>
        <el-button type="primary" @click="application = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 帮助中心 -->
    <help-center ref="helpcenter"></help-center>
    <!-- 个人中心弹出框 -->
    <el-dialog :close-on-click-modal="false" :title="$t('personcenter.个人中心')" :visible.sync="personal" width="50%"
      center>
      <personal @getuserinfo="userNames" @aaa="unSubmit"></personal>
    </el-dialog>
    <!-- 修改密码 -->
    <el-dialog :close-on-click-modal="false" :title="$t('personcenter.修改密码')" :visible.sync="UpdatepwdDialog"
      width="32%" center>
      <el-form :model="updateform" class="width90-ma-auto" style="width: 90%; margin: 0 auto" :rules="rulespwd"
        ref="ruleForm">
        <el-form-item prop="oldpwd" :label="$t('personcenter.旧密码')" label-width="80px">
          <el-input v-model="updateform.oldpwd" type="password" autocomplete="off"
            :placeholder="$t('common.请填写必填项')"></el-input>
        </el-form-item>
        <el-form-item required prop="newpwd" :label="$t('personcenter.新密码')" label-width="80px">
          <el-input v-model="updateform.newpwd" type="password" autocomplete="off"
            :placeholder="$t('common.请填写必填项')"></el-input>
        </el-form-item>
        <el-form-item required prop="newpwd1" :label="$t('personcenter.确认密码')" label-width="80px">
          <el-input v-model="updateform.newpwd1" type="password" autocomplete="off"
            :placeholder="$t('common.请填写必填项')"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="UpdatepwdDialog = false">{{ $t('common.取消') }}</el-button>
        <el-button type="primary" @click="UpdatepwdDialogBtn('ruleForm')">{{ $t('common.确定') }}</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import { api } from "../../lib/asyncFZ";
import personal from "../my/personal";
import userImage from "@/components/userImage";
import { globalMethods } from "@/mixin/langMixin.js";
import {
  outLogin,
  GetUserCompanyList,
  GetMyCompnay,
  GetMyIndex,
  GetNotice,
  GetProjectList,
  GetUserCompanyOpen,
  GetUserInfo,
  GetRoleList,
  IsEnterprise,
  GetCompanyDeptAndJob,
  ApplyToJoinCompany,
  GetApplyRecord,
  SetUrge,
  DelApply,
  GetMessage,
  HandleMsg,
  DelMsg,
} from "@/setAxios";

import helpCenter from "@/components/helpCenter";
export default {
  components: {
    personal,
    helpCenter,
    userImage,
  },
  computed: {},
  name: "admin",
  mixins: [globalMethods],
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.updateform.newpwd !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.updateform.newpwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      isLogo: true,
      personal: false,
      viewShow: true,
      viewShows: true,
      // 这里是修改密码对话框
      UpdatepwdDialog: false,
      updateform: {
        oldpwd: null,
        newpwd: null,
        newpwd1: null,
      },
      UserNames: "",
      JobName: localStorage.lang === "zh" ? "待判断" : "To be Judged",
      ProjectList: [],
      // 这里是排序
      rank: "",
      // 是否企管
      ifEnterprise: this.$store.state.ifEnterprise,
      // 是否项管
      isProject: this.$store.state.isProject,
      // 是否普通用户
      isUser: false,
      controlClick: false, //是否点击控制台
      Company: "",
      CompanyList: [],
      manager: "true",
      query: "",
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
      testList: [],
      listData: [],
      option: {
        step: 1,
        limitMoveNum: 9,
        openTouch: false,
        waitTime: 1,
        direction: 1,
        singleHeight: 35,
      },
      rulespwd: {
        newpwd1: [
          { required: true, message: this.$t('common.请填写必填项'), trigger: "blur" },
        ],
        oldpwd: [{ required: true, message: this.$t('common.请填写必填项'), trigger: "blur" }],
        newpwd: [
          { required: true, message: this.$t('common.请填写必填项'), trigger: "blur" },
          // { min: 8, message: "长度8位以上", trigger: "blur" },
        ],
      },
      xidIsChange: false,
      roleNameIsChange: false,
      roleNameModel: "",
      drawer: false,
      count: 0,
      loading: false,
      activeNames: ["1"],
      // 新增5.0
      dot: false,
      dialogVisible: false,
      FirmForm: {
        companycode: "",
        deptid: "",
        jobid: "",
      },
      job: [],
      dept: [],
      Firmrules: {
        companycode: [
          { required: true, message: "请输入企业编码", trigger: "blur" },
        ],
        deptid: [
          { required: true, message: "请选择企业组织架构", trigger: "change" },
        ],
        jobid: [
          { required: true, message: "请选择企业职位", trigger: "change" },
        ],
      },
      inFromFirm: [],
      inFromProject: [],
      application: false,
      visible: false,
      currentLanguage: localStorage.lang, //当前语言
    };
  },
  created() {
    localStorage.url = this.$store.state.baseUrl;
    this.roleNameModel = this.$store.state.roleName;
    const h = this.$createElement;
    if (this.$store.state.firstlogin) {
      this.$msgbox({
        title: "消息",
        message: h("p", null, [
          h("span", null, "是否前往绑定"),
          h("i", { style: "color: teal" }, "微信"),
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            this.personal = true;
            done();
          } else {
            done();
          }
        },
      });
    }
    this.GetUserCompanyList();
    this.userNames();
    this.GetMessage();
  },
  //利用计算属性
  computed: {
    xidNameupdata() {
      return this.$store.state.xid;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    noMore() {
      return this.count >= 60;
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  //监听执行
  watch: {
    xidNameupdata(newVal, oldVal) {
      // 用来判断岗位是不是需要重新加载，如果项目发生改变则职位true，在需要改变的时候一定要先判断项目发生改变了没
      this.xidIsChange = true;
      this.GetProjectList();
    },
    // 根据输入值的不同获取公司组织架构和企业职位
    FirmForm: {
      handler(newVal, oldVal) {
        console.log("deeewww", newVal, oldVal);
        let params = {
          companycode: newVal.companycode,
        };
        GetCompanyDeptAndJob({ params }).then((res) => {
          this.job = res.Data.job;
          this.dept = res.Data.dept;
        });
      },
      deep: true,
    },
    roleName() {
      this.roleNameModel = this.$store.state.roleName;
      this.roleNameIsChange = true;
    },
  },
  methods: {
    // 消息通知
    async GetMessage() {
      let res = await GetMessage();
      this.inFromProject = res.Data;
      this.dot = this.inFromProject.length > 0 ? true : false;
    },
    Inform() {
      this.visible = !this.visible;
      this.GetMessage();
    },
    consent(data) {
      let params = {
        id: data.Id,
        type: data.Type,
        state: 1,
      };
      HandleMsg(params).then((res) => {
        if (res.Code == 0) {
          this.$message.warning(res.Message);
        } else {
          this.$message({
            type: "success",
            message: this.$t('common.处理成功'),
          });
          this.GetMessage();
        }
      });
    },
    refuse(data) {
      let params = {
        id: data.Id,
        type: data.Type,
        state: 0,
      };
      HandleMsg(params).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: this.$t('common.处理成功'),
          });
          this.GetMessage();
        }
      });
    },
    delect(data) {
      let params = {
        id: data.Id,
        type: data.Type,
      };
      DelMsg(params).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: this.$t('common.处理成功'),
          });
          this.GetMessage();
        }
      });
    },

    openHelp() {
      this.$refs.helpcenter.open();
    },
    // 帮助中心
    load() {
      this.loading = true;
      setTimeout(() => {
        this.count += 10;
        this.loading = false;
      }, 500);
    },
    // ==============
    ShowLogo(is) {
      this.isLogo = is;
    },
    unSubmit() {
      this.personal = false;
    },
    changeJobs(data) {
      this.$store.state.roleName = data.roleName;
      this.roleNameModel = data.roleName;
      this.$store.state.permissions =
        data.roleRight == null ? [] : data.roleRight;
    },
    aas() {
      setTimeout(() => {
        this.userNames();
      }, 600);
    },
    // 获取用户姓名
    userNames() {
      let params = {
        id: localStorage.getItem("id"),
      };
      GetUserInfo({ params }).then((res) => {
        localStorage.setItem("name", res.Data.user04);
        this.UserNames = res.Data.user04;
        if (res.Data.user13 != null)
          this.$store.state.UserImgs =
            this.$store.state.baseUrl + res.Data.user13;
        else this.$store.state.UserImgs = "";
      });
    },
    // 获取公司下的项目
    GetProjectList() {
      let params = {
        pid: localStorage.pid,
        uid: localStorage.getItem("id"),
        pageIndex: 1,
        pageSize: 100000,
      };
      GetProjectList({ params }).then((res) => {
        this.ProjectList = res.Data.list;
        if (!localStorage.xid && !res.Data.list.length) {
          return false;
        }
        let params2 = {
          qid: localStorage.pid,
          xid: localStorage.xid || res.Data.list[0].proj01,
          uid: localStorage.id,
        };
        GetRoleList(params2).then((res) => {
          this.$store.state.jobs = res.Data;
          if (this.xidIsChange) {
            this.$store.state.roleName = res.Data[0].roleName;
            this.xidIsChange = false;
          }
          if (res.Data[0].roleRight != null && this.roleNameIsChange) {
            this.$store.state.permissions = res.Data[0].roleRight.split(",");
            this.roleNameIsChange = false;
          } else {
            this.roleNameIsChange = false;
          }
        });
      });
    },
    // 这里是切换公司
    changeCompany(data) {
      this.JobName = data.DeptJob || "待判断";
      this.$store.state.Company = data.Company;
      localStorage.setItem("pid", data.comu03);
      this.$store.state.shortName = data.comp18;
      this.$store.state.companyLogo =
        this.$store.state.baseUrl + data.CompanyLogo;
      this.$store.commit("pidUpdate", data.comu03);
      this.$store.state.isClickProject = false;
      this.$router.push({
        path: "/enterprise",
      });
      // 这里做下修改
      if (data.comu04 == 0) {
        this.$store.state.ifEnterprise = true;
      } else {
        this.$store.state.ifEnterprise = false;
      }
      this.GetProjectList();
    },
    changeCompany2(data) {
      this.JobName = data.DeptJob || "待判断";
      this.$store.state.Company = data.Company;
      localStorage.setItem("pid", data.comu03);
      this.$store.state.shortName = data.comp18;
      this.$store.state.companyLogo =
        this.$store.state.baseUrl + data.CompanyLogo;
      this.$store.commit("pidUpdate", data.comu03);
      // 这里做下修改
      if (data.comu04 == 0) {
        this.$store.state.ifEnterprise = true;
      } else {
        this.$store.state.ifEnterprise = false;
      }
      this.GetProjectList();
    },
    // 这里记得把项目ID保存下来
    changeProject(data) {
      if (data[2] == 1 || data[2] == 2) {
        this.$store.state.isProject = true;
        this.isUser = false;
      } else {
        this.$store.state.isProject = false;
        this.isUser = true;
      }
      this.$store.state.xid = data[0];
      localStorage.setItem("xid", data[0]);
      this.$store.state.isClickProject = true;
      this.$store.state.xidName = data[3];
      this.$store.state.btnStyle[0] = "btns";
      this.$store.state.btnStyle[1] = "btnss";
      this.$store.state.btnStyle[2] = "btns";
      this.$store.state.btnStyle[3] = "btns";
      let params = {
        qid: localStorage.pid,
        xid: data[0],
        uid: localStorage.id,
      };
      GetRoleList(params).then((res) => {
        this.$store.state.jobs = res.Data;
        this.roleNameModel = res.Data[0].roleName;
        this.$store.state.roleName = res.Data[0].roleName;
        if (res.Data[0].roleRight !== null) {
          this.$store.state.permissions = res.Data[0].roleRight.split(",");
        } else {
          this.$store.state.permissions = [];
        }
      });
    },
    // 获取用户所属公司
    GetUserCompanyList() {
      let params = {
        id: localStorage.getItem("id"),
      };
      GetUserCompanyOpen({ params }).then((res) => {
        this.CompanyList = res.Data;
        if (!this.CompanyList.length) return false;
        if (this.$store.state.Company && localStorage.pid) {
          var isExit = false;
          res.Data.forEach((v) => {
            if (
              v.comu03 == localStorage.pid &&
              v.Company == this.$store.state.Company
            ) {
              isExit = true;
            }
          });
          if (!isExit) {
            this.$store.state.pid = res.Data[0].comu03;
            localStorage.setItem("pid", res.Data[0].comu03);
          }
          let data = this.CompanyList.filter((item) => {
            return item.comu03 == localStorage.pid;
          });
          this.changeCompany2(data[0]);
        } else {
          // 公司简称和公司Logo
          if (res.Data[0].comu04 == 0) {
            this.$store.state.ifEnterprise = true;
          } else {
            this.$store.state.ifEnterprise = false;
          }
          this.JobName = res.Data[0].DeptJob || "待判断";
          this.$store.state.Company = res.Data[0].Company;
          this.$store.state.pid = res.Data[0].comu03;
          localStorage.setItem("pid", res.Data[0].comu03);
          this.$store.state.companyLogo =
            this.$store.state.baseUrl + res.Data[0].CompanyLogo;
          this.$store.state.shortName = res.Data[0].comp18;
        }
      });
    },
    out() {
      outLogin().then((res) => {
        if (res.Code == 1) {
          this.$store.state.isClickProject = false;
          this.$message({
            type: "success",
            message: this.$t('common.处理成功'),
          });
          localStorage.clear();
          this.$store.state.Company = "";
          localStorage.setItem("isLogin", false);
          this.$router.push({
            path: "/login",
          });
        }
      });
    },
    enterpriseIndex() {
      this.$store.state.isClickProject = false;
      this.$store.state.isProject = false;
      this.controlClick = false;
      this.$router.push({
        path: "enterprise",
      });
    },
    control() {
      this.$store.state.isClickProject = false;
      this.controlClick = true;
      this.$router.push({
        path: "/enterpriseManagement",
      });
    },
    project() {
      this.$router.push({
        path: "/ProjectInformation",
      });
    },
    userControls() {
      this.$router.push({
        path: "/userControl",
      });
    },
    // 这里是个人中心
    my() {
      this.personal = true;
    },
    // 这里是修改密码
    Updatepwd() {
      this.updateform = this.$options.data.call(this).updateform;
      this.UpdatepwdDialog = true;
    },
    // 这里是修改密码确定按钮
    UpdatepwdDialogBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let old = this.updateform.oldpwd;
          let news = this.updateform.newpwd;
          let id = localStorage.getItem("id");
          api
            .post("/api/UpdatePwd", { oldpwd: old, newpwd: news, uid: id })
            .then((res) => {
              if (res.Code === 1) {
                this.$message({
                  type: "success",
                  message: this.$t('common.处理成功'),
                });
              } else {
                this.$message.error(this.$t('common.处理失败'));
              }
            });
          this.UpdatepwdDialog = false;
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    //加入企业
    addFirm() {
      this.dialogVisible = true;
      this.$set(this.FirmForm, "companycode");
    },
    submitFirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const val = this.FirmForm;
          let params = {
            companycode: val.companycode,
            deptid: val.deptid,
            jobid: val.jobid,
          };
          ApplyToJoinCompany(params).then((res) => {
            if (res.Code > 0) {
              this.$message({
                type: "success",
                message: this.$t('common.处理成功'),
              });
              this.dialogVisible = false;
              this.FirmForm = {
                companycode: "",
                deptid: "",
                jobid: "",
              };
            } else {
              this.$message({
                type: "error",
                message: "已申请加入过该公司",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    handleClose() {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.dialogVisible = false;
          done();
        })
        .catch((_) => { });
    },
    handleClose1() {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.application = false;
          done();
        })
        .catch((_) => { });
    },
    // 获取申请记录
    GetApplyRecord() {
      this.application = true;
      let params = {
        type: 1,
      };
      GetApplyRecord({ params }).then((res) => {
        if (res.Code > 0) {
          this.inFromFirm = res.Data;
        }
      });
    },
    // 催办
    SetUrge1(id) {
      let params = {
        applyid: id,
        state: 1,
      };
      SetUrge(params).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "催办成功",
          });
          this.GetApplyRecord();
        }
      });
    },
    // 撤销申请
    DelApply(id) {
      let params = {
        applyid: id,
      };
      DelApply(params).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "撤销申请成功",
          });
          this.GetApplyRecord();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.indexIcon {
  font-size: 18px;
  margin-right: 10px;
}

/deep/ .view {
  overflow: auto;
}

.admin-bj {
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.title-left {
  margin-left: 20px;
}

.menu-left {
  margin-right: 20px;
  width: 100%;
}

.el-container {
  width: 100%;
  height: 100%;
}

.el-header {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  line-height: 60px;
  height: 60px;
  padding: 0px;

  .el-col-1 {
    margin-left: 30px;

    img {
      height: 50px;
    }
  }

  .text-4 {
    font-weight: 700;
    font-style: normal;
    // color: #0092d9;
    color: #2f2f2f;
    margin-left: 4px;
    font-size: 20px;
    text-align: left;
    letter-spacing: 2px;
  }

  .text-5 {
    font-style: normal;
    color: #000;
    font-size: 18px;
    text-align: left;
    vertical-align: bottom;
  }
}

.el-aside {
  background-color: #bfcbd9;
  color: #333;
  text-align: center;
  line-height: 200px;
}

.view {
  background-color: #f4f4f5;
  width: 100%;
  height: calc(100vh - 60px);
}

.breadcrumb-container {
  float: left;
}

.right-menu {
  // float: right;
  // width: 100%;
  // height: 60px;
  // line-height: 50px;

  &:focus {
    outline: none;
  }

  .right-menu-item {
    display: inline-block;
    padding: 0 8px;
    height: 100%;
    font-size: 18px;
    color: #5a5e66;
    vertical-align: text-bottom;

    &.hover-effect {
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }


}

/deep/.el-dropdown-menu__item {
  color: black;
  background: #fff;

  &:hover {
    color: #ffbb37;
    background-color: black;
  }
}

/deep/ .el-dropdown-menu,
.el-popper,
.el-dropdown-menu--small {
  background-color: white !important;
}

/deep/ .popper__arrow::after {
  border-bottom-color: #FFFFFF !important;
}


/deep/ .el-dropdown-menu,
.el-dropdown-menu__item--divided {
  border-top: none;

  &::before {
    content: "";
    height: 6px;
    display: block;
    margin: 0 -20px;
    background-color: white !important;
  }
}


.el-dropdown-menu {
  background-color: #1f2d3d;
}

/deep/ .el-dropdown-menu,
.el-dropdown-menu__item--divided {
  border-top: none;

  &::before {
    content: "";
    height: 6px;
    display: block;
    margin: 0 -20px;
    background-color: rgb(25, 36, 49);
  }
}

/deep/ .view {
  overflow: auto;
}

.enterpriseIndex {
  padding: 10px;
}

.item {
  position: relative;
  margin-top: 40px;

  span {
    position: absolute;
    background: #1a78a9;
    display: block;
    height: 30px;
    width: 70px;
    line-height: 30px;
    border-bottom-right-radius: 40%;
    color: #fff;
    top: 0;
    left: 0;
  }

  .el-rate {
    position: absolute;
    top: 80%;
    left: 0;
  }
}

.Pa {
  line-height: 25px;
  height: 300px;
  overflow: hidden;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.el-card {
  margin: 10px 10px 10px 10px;
}

.right-menu .avatar-container .avatar-wrapper[data-v-e741f4b6] {
  margin-top: 0px;
}

// 新增
.img-one {
  width: 40px;
  height: 40px;
  border-radius: 2px;
  margin-left: 3px;
}

.font-sz16 {
  font-size: 16px;
}

.width70 {
  width: 60% !important;
}

.dis-flex {
  display: flex;
  align-items: center;
}

.img-two {
  width: 24px;
  height: 24px;
  margin-right: 5px;
}

.box-one {
  // font-weight: bold;
  // font-size: 14px;
  // color: #a8379b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.box-two {
  // width: 200px;
  font-weight: 700;
  text-align: left;
  // float: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  // margin-right: 20px;
}


.margin0 {
  margin: 0;
}

.dis-bok-wh100 {
  display: block;
  width: 100%;
  height: 100%;
}

.dis-bok {
  display: block;
}

.width90-ma-auto {
  width: 90%;
  margin: 0 auto;
}


// /deep/.el-badge__content.is-fixed {
//   top: 18px;
//   right: 9px;
// }

.Divcard {
  position: absolute;
  width: 80%;
  left: 10%;
  top: 8%;
  text-align: center;
}

.jb {
  //  background: linear-gradient(to right, #2f2f2f, #535353);
  background: white;
}

.Divspan {
  background: url("../../assets/img/Ellipse12.png") no-repeat left center;
  padding-left: 30px;
}

.Divp {
  text-align: center;
  line-height: 40px;
  margin-top: 20px;
}

.drawerHeader {
  text-align: center;
  height: 120px;
  font-size: 20px;
}
</style>
